<div *transloco="let t; read: 'profile-list-card'"
  [class.no-hover]="isMobile"
  [class.ghost]="!profile().id"
  class="profile-card tile">

  <a class="details"
    [attr.aria-labelledby]="'profile-'+ profile().id"
    [routerLink]="['/profile', profile().id]"
    [queryParams]="queryParams">
    <div class="profile-wrapper">
      <accredible-avatar [imageUrl]="profile().avatar_url"
        [name]="profile().name"
        [isLoading]="!profile().id"
        [withBorder]="false"
        shape="square"
        size="80px"/>

      <div class="profile-meta">
        <h2 class="mat-h2"
          [attr.id]="'profile-'+ profile().id"
          [attr.aria-label]="t('aria_name', {name: profile().name})">{{ profile().name }}</h2>

        @if (!profile().id || (profile().location?.name || profile().updated_at)) {
          <div class="address-date">
            @if (profile().location?.name) {
              <div class="mat-h4">
                <mat-icon>location_on</mat-icon>
                <span [attr.aria-label]="t('aria_address')">
                  {{ profile().location?.name }}
                </span>
              </div>
            }

            @if (profile().updated_at) {
              <div class="mat-h4 updated-at">
                <mat-icon>schedule</mat-icon>
                <span [attr.aria-label]="t('aria_update_date')">
                  {{ profile().updated_at | localeDate:'mediumDate': (languageCode$ | async) }}
                </span>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <div class="skills-and-credentials">
      @if (!profile().id || profile().bio?.length > 0) {
        <p contentFade="100"
          class="biography"
          [attr.aria-label]="t('aria_biography')">
          {{ profile().bio }}
        </p>
      }

      @if (!profile().id || profile().skills?.length > 0) {
        <div class="skills"
          [attr.aria-label]="t('aria_skills')">
          <span aria-hidden="true">{{ t('skills') }}:&nbsp;</span>

          @for (skill of profile().skills | slice:0:skillsLimit; track skill; let last = $last) {
            <span [class.trailing-margin]="last">
            {{ skill }}{{ last ? '' : '&nbsp;-&nbsp;' }}
          </span>

          }

          @if (profile().skills?.length > skillsLimit) {
            <div class="overflow-message">
              {{ t('plus_more_skills', { count: profile().skills.length - skillsLimit }) }}
            </div>
          }
        </div>
      }


      @if (!profile().id || profile().credentials?.length > 0) {
        <div class="credentials">
          <accredible-chip-list [chips]="mappedCredentials() | slice: 0:credentialLimit"
            [attr.aria-label]="t('aria_credentials')"
            class="trailing-margin"/>

          @if (mappedCredentials()?.length > credentialLimit) {
            <div class="overflow-message">
              {{ t('plus_more_credentials', { count: mappedCredentials()?.length - credentialLimit }) }}
            </div>
          }
        </div>
      }

      <div class="user-custom-attributes">
        <sl-user-custom-attributes [customProfileAttributes]="profile().custom_attributes_values"/>
      </div>
    </div>
  </a>

  <div class="avatar-wrapper">
    <a aria-hidden="true"
      tabindex="-1"
      [routerLink]="['/profile', profile().id]"
      [queryParams]="queryParams">
      <accredible-avatar [imageUrl]="profile().avatar_url"
        [name]="profile().name"
        [isLoading]="!profile().id"
        [withBorder]="false"
        shape="square"
        size="120px"/>
    </a>

    <sl-social-links [socialLinks]="profile().social_media"
      [name]="profile().name"
      [ariaLabel]="t('aria_social_links', { name: profile().name })"
      (socialNetworkClicked)="trackEvent($event)"/>
  </div>
</div>
